import { easeOutCubic } from '@/util/easeFunctions'
import { transformNumbersToRange } from '@/util/numberHelpers'
import React, { useEffect, useRef, useState } from 'react'
import { ScarcityMeter } from './ScarcityMeter'

export default function AnimatedScarcityMeter({
  className
}: {
  className?: string
}) {
  const [value, setValue] = useState(100)
  const valueRef = useRef(100)

  useEffect(() => {
    const interval = setInterval(
      () => {
        setValue(prev => {
          let result: number
          if (prev === 0) {
            result = 100
          } else {
            result = --prev
          }
          valueRef.current = result
          return result
        })
      },
      valueRef.current === 0
        ? 1000
        : easeOutCubic(transformNumbersToRange(valueRef.current, 0, 16, 0, 1)) +
            10
    )

    return () => clearInterval(interval)
  }, [valueRef.current])

  return <ScarcityMeter percentage={value} className={className} />
}
